var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

function CardTabs(el) {
	var t = this;
	var cards = Array.prototype.slice.call( el.querySelectorAll('.js-card-row') );
	t.$el = $(el);
	t.$mobileFilter = t.$el.find('[data-field-mobile]');
	t.$currentFilter = t.$el.find('[data-field-current]');
	t.$items = t.$el.find('.js-card-row');

	// Set default state
	var firstItem = t.$mobileFilter.find('option:first-child');
	t.$mobileFilter.val( firstItem.val() );
	t.$currentFilter.text( firstItem.text() );

	t.$mobileFilter.on('change', function() {
		var selectedFilter = this.value,
				text = $(this).find('[value="' + selectedFilter + '"]').text();
		if( selectedFilter === 'all' ) {
			t.$items.addClass( 'js-filter-visible' );
			t.$currentFilter.text('All');
		} else {
			t.$items.removeClass( 'js-filter-visible' );
			t.$items.filter( '[data-filter-type*="|' + selectedFilter + '|"]' ).addClass( 'js-filter-visible' );
			t.$currentFilter.text( text );
		}
	});

	// Tap on Image mobile
	cards.forEach(function(elem){
		var image = elem.querySelector('.js-card-row-image');

		image.addEventListener('touchstart', function (event) {
			if ( screen.width < 767 ) {
				elem.classList.toggle('card-row--tap');
				event.preventDefault();
			}
		});
	});


}
module.exports = CardTabs;
